import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '../../lib/utils';
export function Card({ className, children, hover, ...props }) {
    return (_jsx("div", { className: cn('bg-white rounded-2xl border border-gray-100 shadow-sm', hover && 'hover:shadow-md hover:border-gray-200 transition-shadow duration-150 cursor-pointer', className), ...props, children: children }));
}
export function CardHeader({ className, children, ...props }) {
    return (_jsx("div", { className: cn('px-5 py-4 border-b border-gray-100', className), ...props, children: children }));
}
export function CardBody({ className, children, ...props }) {
    return (_jsx("div", { className: cn('px-5 py-4', className), ...props, children: children }));
}
export function CardFooter({ className, children, ...props }) {
    return (_jsx("div", { className: cn('px-5 py-3 border-t border-gray-100 bg-gray-50/50 rounded-b-2xl', className), ...props, children: children }));
}
